import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
// 数据源
import { ListStore } from '../../../../store';
// 素材
import heartFalse from '@src/mobile/details/layout/assets/heartFalse.png';
import heartTrue from '@src/mobile/details/layout/assets/heartTrue.png';
// 组件
import { message } from '@src/components/ModalBox';
// 视频点赞
import { postLikeVideo, getLikeVideo } from '@src/utils/base';
import { getlocal, setlocal } from '@src/utils';

// 统计
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import { Grounds } from '@ifeng-fe/client_grounds';
const Like = ({ content }) => {
    // 获取状态数据
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const { dramaSeries } = listStates;
    const { base62Id } = dramaSeries;
    const [showLike, setShowLike] = useState(false);
    const [likeNum, setLikeNum] = useState();
    // 统计
    // action
    const sendAction = (
        type, // 剧集id
    ) => {
        Grounds.actionStat({
            behavior: 'action',
            id: `phmovie_${dramaSeries.base62Id}`,
            type: `phmovie_${type}`,
            pty: 'phmovie',
        });
        // pageStatistics({
        //     behavior: 'action',
        //     id: `phmovie_${dramaSeries.base62Id}`,
        //     type: `phmovie_${type}`,
        //     pty: 'phmovie',
        // });
    };
    // 设置点赞
    const postLike = async () => {
        // 本地
        const historyObj = getlocal('history');
        const dramaSeriesData = historyObj.find(item => item.id === base62Id);

        // 开启
        if (!showLike) {
            // UI
            setShowLike(true);
            setLikeNum(likeNum + 1);
            // 本地
            dramaSeriesData.like = true;
            setlocal('history', historyObj);
            // 接口
            await postLikeVideo(base62Id);
            // 弹窗
            message({
                content: (
                    <div className={styles.success}>
                        <div className={styles.successText}>点赞成功</div>
                    </div>
                ),
            });
            // 统计
            sendAction('upvote');
        } else {
            // 关闭
            // UI
            setShowLike(false);
            setLikeNum(likeNum - 1);
            // 本地
            dramaSeriesData.like = false;
            setlocal('history', historyObj);
            // 弹窗
            message({
                content: (
                    <div className={styles.success}>
                        <div className={styles.successText}>取消点赞</div>
                    </div>
                ),
            });
            // 统计
            sendAction('cacnelvote');
        }
    };

    // 获取点赞
    const getLike = async () => {
        // 接口
        const videoLike = await getLikeVideo(base62Id);
        const num = videoLike[`${base62Id}ding`];
        // 本地
        const historyObj = getlocal('history');
        const dramaSeriesData = historyObj.find(item => item.id === base62Id);

        if (dramaSeriesData.like) {
            // 开启
            // UI
            setShowLike(true);
            setLikeNum(num + 1);
        } else {
            // 关闭
            // UI
            setShowLike(false);
            setLikeNum(num);
        }
    };

    useEffect(() => {
        // 获取点赞数量
        getLike();
    }, []);

    return (
        <div className={styles.like} onClick={postLike}>
            <img className={styles.likeIcon} src={showLike ? heartTrue : heartFalse} alt="" />
            <div className={styles.likeTitle}>{likeNum ? likeNum : '喜欢'}</div>
        </div>
    );
};

Like.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Like);
